import angular, { element } from "angular";
import { ISubFilter } from "./subFilters/subFilters";
import { IQuery } from "../../../server/query";
import { ColDef } from "../colDef";

const gridFilterTemplate = require("!html-loader!./gridFilter.html");
const filterTemplate = element(gridFilterTemplate.default);
interface GridFilterScope extends angular.IScope {
  gridFilterController: GridFilter;
}
export class GridFilter implements awk.Filter {
  private readonly subFilters: ISubFilter[];
  private $scope: GridFilterScope | undefined;
  private currentSubFilterScope: angular.IScope | undefined;
  private subfilterContainer: JQuery | undefined;
  private selectedSubFilter: ISubFilter | undefined;
  readonly defaultModelOptions: angular.INgModelOptions;

  private static compiledGridTemplate:
    | angular.ITemplateLinkingFunction
    | undefined;
  private readonly subFilterLinkFunctionLookup: Map<
    ISubFilter,
    angular.ITemplateLinkingFunction
  > = new Map<ISubFilter, angular.ITemplateLinkingFunction>();

  constructor(subFilters: ISubFilter[], $compile: angular.ICompileService) {
    this.subFilters = subFilters;
    this.defaultModelOptions = {
      debounce: { default: 500, blur: 0 },
    };

    subFilters.forEach((sf) => {
      sf.init({ gridFilter: this });
      const element = sf.getGui();
      const linkingFunction = $compile(element);
      this.subFilterLinkFunctionLookup.set(sf, linkingFunction);
    });
    GridFilter.compiledGridTemplate =
      GridFilter.compiledGridTemplate || $compile(filterTemplate);
  }

  selectedSubFilterChanged() {
    if (!this.selectedSubFilter) {
      return;
    }
    this.setFilter(this.selectedSubFilter);
  }

  clearAllFilters() {
    const queryObject = this.getQueryObject();
    this.subFilters.forEach((sf) => {
      sf.queryFieldNames.forEach((qfn) => {
        delete queryObject[qfn];
      });
    });
  }

  init(params: {
    colDef: ColDef;
    rowModel: any;
    filterChangedCallback: () => void;
    filterModifiedCallback: () => void;
    valueGetter: (node: any) => any;
    filterParams: any;
    $scope: GridFilterScope;
  }) {
    this.$scope = params.$scope;
    params.$scope.gridFilterController = this;
  }

  setFilter(subFilter: ISubFilter) {
    this.selectedSubFilter = subFilter;
    this.currentSubFilterScope?.$destroy();

    const parentScope = this.$scope!;
    const newScope = parentScope.$new(false);

    const templateFunction = this.subFilterLinkFunctionLookup.get(subFilter)!;
    const subfilterElement = templateFunction(newScope, () => {});

    this.currentSubFilterScope = newScope;
    subFilter.beforeActivate({ $scope: newScope });

    this.subfilterContainer?.empty();
    this.subfilterContainer?.append(subfilterElement);

    this.clearAllFilters();
  }

  getGui(): HTMLElement | string {
    const template: JQLite = filterTemplate.clone();
    this.subfilterContainer = template.find('[name="inputContainer"]');

    return template[0];
  }

  getQueryObjectExpression(): string {
    return "recordGridController.currentQuery";
  }

  getQueryObject(): IQuery {
    return this.$scope?.$eval(this.getQueryObjectExpression());
  }

  isFilterActive(): boolean {
    const queryFieldNames = new Set<string>();
    this.subFilters.forEach((subFilter) => {
      subFilter.queryFieldNames.forEach((queryFieldName) => {
        queryFieldNames.add(queryFieldName);
      });
    });

    const queryObject = this.getQueryObject();
    const matchingEntry = Object.entries(queryObject).find(
      ([queryObjectFieldName, queryObjectFieldValue]) =>
        queryFieldNames.has(queryObjectFieldName) &&
        queryObjectFieldValue !== null &&
        queryObjectFieldValue !== undefined
    );

    return Boolean(matchingEntry);
  }
  doesFilterPass(params: any): boolean {
    return true;
  }

  afterGuiAttached(params?: { hidePopup?: Function }): void {
    if (!this.selectedSubFilter) {
      const firstEntry = this.subFilters[0];
      this.setFilter(firstEntry);
    }
  }
}
